import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C51SideStatisticsItemFields = {
  Prefix?: Field<string>;
  Statistic?: Field<string>;
  Suffix?: Field<string>;
  SupportCopy?: Field<string>;
};

export type C51SideStatisticsItemProps = RenderingProps<
  C51SideStatisticsItemFields,
  DynamicPlaceholderParams & TranslationOptionsParams & AnchorTargetParams
>;
